import { parse, stringify, ParsedQuery } from 'query-string';

export const parseQueryParams = (locationSearch: string): ParsedQuery<string> | null =>
  locationSearch ? parse(locationSearch) : null;

export const buildSearchQueryParams = (params: { [key: string]: string | number } = {}): string => {
  if (Object.keys(params).length === 0) return '';
  else return `?${stringify(params)}`;
};
